"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = void 0;
// eslint-disable-next-line no-restricted-imports
const react_i18next_1 = require("react-i18next");
function useTranslation() {
    return (0, react_i18next_1.useTranslation)(process.env.TRANSLATION_NAMESPACE);
}
exports.useTranslation = useTranslation;
//# sourceMappingURL=use-translation-wrapper.js.map